var base = require('settings/teams/pending-invitations');

Vue.component('spark-pending-invitations', {
    mixins: [base],
    data() {
        return {
            headers: [{
                text: 'Name', value: 'name',  align: 'left'
            },{
                value: 'accept', sortable: false,  align: 'right'
            },{
                value: 'reject', sortable: false,  align: 'right'
            }]
        };
    }
});
